import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { Stack as d, Box as c, Typography as n } from "@mui/material";
import { formatMoney as e } from "../../helpers/strings.js";
const u = (i) => {
  const { amount: t, fee: a, gst: l, total: h } = m(i);
  return /* @__PURE__ */ r(d, { children: [
    /* @__PURE__ */ r(d, { direction: "row", spacing: 1, children: [
      /* @__PURE__ */ r(c, { flexGrow: 1, children: [
        /* @__PURE__ */ o(n, { variant: "caption", children: "Amount" }),
        /* @__PURE__ */ o(n, { children: t })
      ] }),
      a && /* @__PURE__ */ r(c, { flexGrow: 1, children: [
        /* @__PURE__ */ o(n, { variant: "caption", children: "Fee" }),
        /* @__PURE__ */ o(n, { children: a })
      ] })
    ] }),
    /* @__PURE__ */ r(c, { children: [
      /* @__PURE__ */ o(n, { variant: "caption", children: "Total" }),
      /* @__PURE__ */ o(n, { fontWeight: 600, children: h }),
      l && /* @__PURE__ */ r(n, { variant: "caption", children: [
        "Includes a GST of ",
        l
      ] })
    ] })
  ] });
}, m = ({ Amount: i, Fee: t, GST: a }) => ({
  amount: e(i / 100),
  fee: t ? e(t / 100) : null,
  total: e((t ? t + i : i) / 100),
  gst: a ? e(a / 100) : null
});
export {
  u as PaymentAmount,
  m as getFormattedAmounts
};
//# sourceMappingURL=PaymentAmount.js.map
